import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './app-services/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

  isLoggedIn$;

  constructor(
    private router: Router,
    private authService: AuthService) {}

  canActivate() {
    this.authService.isLoggedIn.subscribe( res => this.isLoggedIn$ = res);

    // if (!this.authService.isTokenExpired() && this.isLoggedIn$) {
    if (!this.authService.isTokenExpired()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/auth.guard.ts